import React, { useState, useContext } from 'react';
import { AppContext } from '../context/AppContext';
import api from '../services/api';

export default function UploadMaterials({ onNext, onError }) {
  const { appState, updateState } = useContext(AppContext);
  const [sampleText, setSampleText] = useState('');
  const [googleDriveUrl, setGoogleDriveUrl] = useState('');
  const [driveLoading, setDriveLoading] = useState(false);

  const handleAnalyze = async () => {
    if (!sampleText.trim() && !googleDriveUrl.trim()) {
      onError('Por favor, insira um material ou URL do Google Drive');
      return;
    }

    updateState({ loading: true, error: null });
    if (googleDriveUrl.trim()) setDriveLoading(true);

    try {
      const response = await api.post('/materials/analyze', {
        sampleText: sampleText.trim(),
        googleDriveUrl: googleDriveUrl.trim()
      });

      if (response.data.status === 'sucesso') {
        updateState({
          material: sampleText || googleDriveUrl,
          resumo: response.data.resumo,
          topicos: response.data.resumo.topicos || [],
          loading: false
        });
        onNext();
      }
    } catch (error) {
      const msg = error.response?.data?.error || error.message;
      onError(msg);
      updateState({ loading: false });
    } finally {
      setDriveLoading(false);
    }
  };

  const isValidDriveUrl = (url) =>
    url.includes('docs.google.com') || url.includes('drive.google.com');

  return (
    <div className="step-content">

      {/* Opção 1: Link do Google Drive */}
      <div className="form-group">
        <label>🔗 Link do Google Drive</label>
        <input
          type="url"
          value={googleDriveUrl}
          onChange={(e) => setGoogleDriveUrl(e.target.value)}
          placeholder="https://docs.google.com/document/d/..."
          className={`input ${googleDriveUrl && !isValidDriveUrl(googleDriveUrl) ? 'input-error' : ''}`}
          disabled={appState.loading}
        />
        {googleDriveUrl && !isValidDriveUrl(googleDriveUrl) && (
          <small style={{ color: '#be1621' }}>
            ⚠️ Use um link do Google Docs, Google Slides ou Google Drive
          </small>
        )}
        {!googleDriveUrl && (
          <small>
            Suporta: Google Docs e Google Slides públicos.{' '}
            <strong>O arquivo precisa estar compartilhado como "Qualquer pessoa com o link".</strong>
          </small>
        )}
        {driveLoading && (
          <small style={{ color: '#385e81' }}>
            ⏳ Baixando conteúdo do Google Drive...
          </small>
        )}
      </div>

      <div className="or-divider">OU</div>

      {/* Opção 2: Texto colado */}
      <div className="form-group">
        <label>📝 Cole o texto do material aqui</label>
        <textarea
          value={sampleText}
          onChange={(e) => setSampleText(e.target.value)}
          placeholder="Cole o conteúdo do material de aula aqui..."
          rows="8"
          className="textarea"
          disabled={appState.loading}
        />
      </div>

      {/* Instruções de compartilhamento */}
      {googleDriveUrl && isValidDriveUrl(googleDriveUrl) && (
        <div className="info-box" style={{ marginBottom: 16 }}>
          {googleDriveUrl.includes('/folders/') ? (
            <>
              <strong>📁 Lendo pasta do Google Drive (PDFs)</strong>
              <ol style={{ marginLeft: 18, marginTop: 8 }}>
                <li>Abra a pasta no Google Drive</li>
                <li>Clique com botão direito → <strong>Compartilhar</strong></li>
                <li>Selecione <strong>"Qualquer pessoa com o link"</strong> → Leitor</li>
                <li>Cole o link aqui ✓</li>
              </ol>
              <p style={{ marginTop: 8, fontSize: '0.85rem', color: '#385e81' }}>
                ✅ Suporte a PDFs ativo. O app vai baixar e extrair o texto de todos os PDFs da pasta automaticamente.
              </p>
            </>
          ) : (
            <>
              <strong>📋 Como compartilhar o documento:</strong>
              <ol style={{ marginLeft: 18, marginTop: 8 }}>
                <li>Abra o documento no Google Docs</li>
                <li>Clique em <strong>Compartilhar</strong> (canto superior direito)</li>
                <li>Em "Acesso geral", selecione <strong>"Qualquer pessoa com o link"</strong></li>
                <li>Permissão: <strong>Leitor</strong> → Copie e cole aqui</li>
              </ol>
            </>
          )}
        </div>
      )}

      <button
        onClick={handleAnalyze}
        disabled={
          appState.loading ||
          (!sampleText.trim() && !googleDriveUrl.trim()) ||
          (googleDriveUrl.trim() && !isValidDriveUrl(googleDriveUrl))
        }
        className="btn btn-primary"
      >
        {appState.loading
          ? driveLoading ? '⏳ Lendo Google Drive...' : '⏳ Analisando...'
          : '✨ Analisar Material'}
      </button>
    </div>
  );
}
